export function omit<T extends object, K extends readonly (keyof T)[]>(
  obj: T,
  keys: K
): Omit<T, K[number]> {
  const rest: Partial<T> = { ...obj };
  for (const key of keys) {
    // eslint-disable-next-line @typescript-eslint/no-dynamic-delete -- removing the caller's keys is the whole function
    delete rest[key];
  }
  return rest as Omit<T, K[number]>;
}
